export const optionContentStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const startAdornmentStyles = {
  margin: '0 -6px 0 8px',
};
